import React from 'react';
import { Col } from 'react-styled-flexboxgrid';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const SingleColumnLogoAndText = ({ blok }) => (
  <Col
    {...storyblokEditable(blok)}
    xs={8}
    md={10}
    lg={12}
    className={clsx('text-center pt-[26px] pb-[18px]', {
      'border-t-[.75px] border-solid border-gray-100': blok.includeTopBorder,
    })}
  >
    <img alt={blok.logo?.alt ?? ''} className="w-[69px] lg:w-[93px] my-0 mx-auto" src={blok.logo?.filename} />
    <p className="typography-body-xxxs sm:typography-body-xxs text-[#fff] pt-[8px] sm:pt-[10px]">{blok.text}</p>
  </Col>
);

SingleColumnLogoAndText.propTypes = {
  blok: PropTypes.any.isRequired,
};

export default SingleColumnLogoAndText;
